import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    bankAccounts: [],
    loading: false
};

const treasurySlice = createSlice({
    name: 'treasury',
    initialState,
    reducers: {
        setBankAccounts: (state, action) => {
            state.bankAccounts = action.payload;
        },
        setLoading: (state, action) => {
            state.loading = action.payload;
        }
    }
});

export const { setBankAccounts, setLoading } = treasurySlice.actions;
export const selectBankAccounts = (state) => state.treasury.bankAccounts;
export const selectTreasuryLoading = (state) => state.treasury.loading;

export default treasurySlice.reducer;
